import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

export const ScrollArea = styled(Box)`
	overflow-y: auto;
	height: 100%;

	/* Apple-style: thin, rounded, no track, only visible while hovering */
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;

	&:hover {
		scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
	}

	::-webkit-scrollbar {
		width: 8px;
	}
	::-webkit-scrollbar-track {
		background: transparent;
	}
	::-webkit-scrollbar-thumb {
		background: transparent;
		border-radius: 8px;
		background-clip: padding-box;
		border: 2px solid transparent;
	}
	&:hover::-webkit-scrollbar-thumb {
		background-color: rgba(0, 0, 0, 0.25);
	}
	::-webkit-scrollbar-thumb:hover {
		background-color: rgba(0, 0, 0, 0.4);
	}
`;

export const Intro = styled(Box)`
	color: ${tokens.text.secondary};
	font-size: 14px;
	line-height: 1.5;
`;

export const ExplanationList = styled.ul`
	margin: 8px 0;
	padding: 0 16px 8px 36px;
	list-style: disc;
	color: ${tokens.text.secondary};
	font-size: 14px;
	line-height: 1.5;

	li + li {
		margin-top: 4px;
	}
`;

export const Row = styled(Flex)`
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	border-top: 1px solid ${tokens.border.subtle};
`;

export const FactorSection = styled(Box)`
	/* Eerste rij grenst al aan de rand van de Card; geen dubbele lijn tekenen. */
	&:first-child > ${Row} {
		border-top: none;
	}
`;

export const DashPlaceholder = styled(Box)`
	width: 12px;
	height: 2px;
	border-radius: 1px;
	background: ${({ theme }) => theme.colors.lightBlueDark};
`;

export const FactorLabel = styled(Box)<{ $inactive: boolean }>`
	flex-grow: 1;
	font-size: 15px;
	font-weight: 600;
	color: ${({ theme, $inactive }) =>
		$inactive ? theme.colors.lightBlueDark : tokens.text.primary};
`;

export const Weight = styled(Box)`
	color: ${tokens.text.secondary};
	font-size: 15px;
`;

export const LevelTable = styled.table`
	width: 100%;
	margin-top: 8px;
	border-collapse: collapse;
	color: ${tokens.text.secondary};
	font-size: 14px;

	th,
	td {
		text-align: left;
		padding: 6px 8px;
		border-bottom: 1px solid ${tokens.border.subtle};
	}

	th {
		color: ${tokens.text.primary};
		font-weight: 600;
	}
`;
